import { PageLocatorMap } from '../types/PageLocatorMap';

export const SignInPinVerifyPage = {
  alert: {
    error: 'signin-pin-verify.alert.error',
    success: 'signin-pin-verify.alert.success',
  },
  footer: {
    root: 'signin-pin-verify.footer',
  },
  form: {
    h1: 'signin-pin-verify.form.heading1',
    h3: 'signin-pin-verify.form.heading3',
    pinInput1: 'signin-pin-verify.form.pin-input-1',
    pinInput2: 'signin-pin-verify.form.pin-input-2',
    pinInput3: 'signin-pin-verify.form.pin-input-3',
    pinInput4: 'signin-pin-verify.form.pin-input-4',
    pinInput5: 'signin-pin-verify.form.pin-input-5',
    pinInput6: 'signin-pin-verify.form.pin-input-6',
    pinInputError: 'signin-pin-verify.form.pin-error',
    resendPinLink: 'signin-pin-verify.form.resend-pin-link',
    root: 'signin-pin-verify.form.root',
  },
  header: {
    root: 'signin-pin-verify.header',
    signUpLink: 'signin-pin-verify.header.signup-link',
  },
} as const satisfies PageLocatorMap;
